import React from 'react'
import PropType from 'prop-types'
import cx from 'classnames'

import { isMobile } from '@cred/shared/utils'

import CtaButton from 'components/cta-button'
import useMaxCTALengthWarning from 'components/hooks/useMaxCTALengthWarning'
import relValue from 'utils/rel-value/relValue'
import { WSJ_THEME } from 'common/constants'
import getLayoutConfig from 'utils/getLayoutConfig'

import styles from './styles.module.scss'
import simpleCtaConfig from '../simple-cta/simpleCtaConfig'

const DEFAULT_VARIATIONS = {
  'compare-rates': 'Compare Rates',
  'find-my-rate': 'Find My Rate',
  'learn-more': 'Learn More',
}
const DEFAULT_ID = 'simple-cta-auto-insurance-variation'

const SimpleCta = (props) => {
  const {
    variation,
    onClickHandle,
    customCTA,
    large = false,
    variations = DEFAULT_VARIATIONS,
    uniqueId = DEFAULT_ID,
    theme,
  } = props
  const className = large ? styles.large : styles.small
  const { AboveCta, BelowCta, Nmls } = getLayoutConfig(theme, simpleCtaConfig)
  useMaxCTALengthWarning({ customCTA, large, uniqueId })
  const isWsj = theme === WSJ_THEME

  return (
    <div className={cx(isWsj ? styles.adWrapper : styles.wrapper)}>
      <AboveCta />
      <CtaButton
        className={cx(className, {
          [styles.truncated]: customCTA,
          [styles.fullWidth]: isWsj && isMobile(),
        })}
        onClick={onClickHandle}
        target="_blank"
        rel={relValue()}
      >
        {customCTA || variations[variation]}
      </CtaButton>
      <Nmls />
      <BelowCta />
    </div>
  )
}

SimpleCta.propTypes = {
  variation: PropType.string.isRequired,
  uniqueId: PropType.string,
  variations: PropType.object,
  large: PropType.bool,
  onClickHandle: PropType.func,
  customCTA: PropType.string,
  theme: PropType.string,
}

export default SimpleCta
